<template>
<!-- <CompanyPolicy></CompanyPolicy> -->
<div class="col-xxl-12 mb-5">
    <!-- <ECShopAdvisory></ECShopAdvisory> -->
  </div>


  <div v-show="loading"> 
  <el-skeleton :rows="10" animated />
</div>
  <div class="col-xxl-12" v-show="!loading">
      <!--begin::Reorder History-->
    <div :class="widgetClasses" class="card">
      <!--begin::Header-->
      <div class="card-header border-0 pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bolder fs-3 mb-1">Reorder History</span>
        </h3>
      </div>
      <!--end::Header-->

      <!--begin::Body-->
      <div class="card-body py-3">
        <!--begin::Table container-->
        <div class="table-responsive">
          <!--begin::Table-->
          <table class="table align-middle gs-0 gy-4">
            <!--begin::Table head-->
            <thead>
              <tr class="fw-bolder text-muted bg-light">
                <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
                <th class="min-w-200px">Date</th>
                <th class="min-w-225px">Product</th>
                <th class="min-w-200px">PV</th>
                <th class="min-w-100px">COMPV</th>
                <th class="min-w-100px">POSPV</th>
              </tr>
            </thead>
            <!--end::Table head-->
            <!--begin::Table body-->
            <tbody>
              <template v-for="(item, index) in list" :key="index">
                <tr>
                  <td>&nbsp;&nbsp;&nbsp;{{item.id}}</td>
                  <td>{{item.dtestp}}</td>
                  <td>{{item.prod}}</td>
                  <td>{{item.ppv}}</td>
                  <td>{{numberWithCommas(item.compv)}}</td>
                  <td>{{item.pospv}}</td>
                </tr>
              </template> 
            </tbody>
            <!--end::Table body-->
          </table>
          <!--end::Table-->
        </div>
        <!--end::Table container-->
      </div>
      <!--begin::Body-->
    </div>
  <!--end::Reorder History-->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import pagination from 'vue-bootstrap-pagination'
import {reorderhistory}  from "@/api/reorder";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";

export default defineComponent({
  name: "reorder",
  components: {
    // CompanyPolicy,
    // ECShopAdvisory
  },
  data() {
    return { 
      list : [],
      pagination: {
        total: 0,
        per_page: 10,    // required
        current_page: 1, // required
        last_page: 0,    // required
        from: 1,
        to: 12,
      },
       loading: true,
    }
  },
  mounted(){
      this.reorderhistory();
  },
  methods : {
    async reorderhistory(){
      this.loading = true;
      const options = {
        params: {
          paginate: this.pagination.per_page,
          page: this.pagination.current_page,
          /* additional parameters */
        }
      };
      
      const response = await reorderhistory(1);
      this.list = response.data.pageList;
      this.pagination = response.data.pagination;
      this.loading = false;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("reorderTab") || "0");
      setCurrentPageTitle("Reorder");

    });
    
  }
});
</script>
